import React, { useState } from 'react';
import './Header.css';

const Header = ({ language, onLanguageChange }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const translations = {
    en: {
      home: 'HOME',
      about: 'ABOUT',
      services: 'SERVICES',
      contact: 'CONTACT',
      getQuote: 'GET QUOTE',
    },
    ar: {
      home: 'الرئيسية',
      about: 'حول',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      getQuote: 'احصل على عرض سعر',
    },
  };

  const t = translations[language];

  const handleLanguageToggle = (lang) => {
    onLanguageChange(lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };

  return (
    <header>
      <div className="header-container">
        <div className="logo-section"></div>

        <nav className={menuOpen ? 'active' : ''}>
          <a href="#home" onClick={() => setMenuOpen(false)}>{t.home}</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>{t.about}</a>
          <a href="#services" onClick={() => setMenuOpen(false)}>{t.services}</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>{t.contact}</a>
        </nav>

        <div className="header-controls">
          <div className="language-toggle">
            <button
              className={language === 'en' ? 'active' : 'inactive'}
              onClick={() => handleLanguageToggle('en')}
            >
              EN
            </button>
            <button
              className={language === 'ar' ? 'active' : 'inactive'}
              onClick={() => handleLanguageToggle('ar')}
            >
              AR
            </button>
          </div>
          <button className="get-quote-btn">{t.getQuote}</button>
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
